import React from "react";
import Pages from "@komon/navigation/navbar/pages";
import { useNavbarPages } from "@radarly/core/navigation/use-cases";
import { IRouterService } from "@radarly/shared/router";

interface NavbarPagesProps {
  router: IRouterService;
}

export function NavbarPages({ router }: NavbarPagesProps) {
  const { pages, limit, locale } = useNavbarPages(router);
  return <Pages pages={pages} more={limit} locale={locale} />;
}
